<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label class="margin-bottom-small">
      {{ $t(`aLogoEdition.${entity}.label`) }}
    </label>
    <span class="a-logo-edition">
      <span :class="`a-logo-edition-img-${clase}`">
        <img
          v-if="logoImg.length"
          key="logoImgTag"
          id="logoImgTag"
          :src="logoImg"
        >
        <img
          v-else
          key="defaultImg"
          id="logoImgTag"
          src="@/assets/img/logo-edition.png"
        >
      </span>
      <a
        :class="`font-size-small text-link-hover-${clase}`"
        href="#"
        @click.prevent="changeLogoImage('inputImagen')"
      >
        {{ $t('aLogoEdition.changeLogo') }}
      </a>
    </span>
    <input
      v-show="false"
      name="file"
      id="inputImagen"
      ref="file"
      type="file"
      value=""
      @change="previewLogoImage"
    >
    <small class="display-flex-column font-weight-light margin-top-medium">
      <span><i>{{ $t(`aLogoEdition.${entity}.messages.dimensions`) }}</i></span>
      <span><i>{{ $t(`aLogoEdition.${entity}.messages.extensions`) }}</i></span>
    </small>
    <small
      v-if="!isFileExtensionValid"
      class="text-color-danger"
    >
      {{ messageErrorFileExtension }}
    </small>
    <small
      v-if="!isFileSizeValid"
      class="text-color-danger"
    >
      {{ messageErrorFileSize }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomLogoEdition',

  props: {
    clase: String,

    entity: String,

    logoImg: {
      type: String,
      default: ''
    },

    wrapperClass: String
  },

  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true,
      inputError: false
    }
  },

  computed: {
    messageErrorFileExtension () {
      return this.$t('aLogoEdition.validation.file.extension')
    },

    messageErrorFileSize () {
      return this.$t('aLogoEdition.validation.file.size')
    }
  },

  methods: {
    changeLogoImage (inputId) {
      document.getElementById(inputId).click()
    },

    previewLogoImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.clase === 'academy'
        ? this.$files.allowedFileExtension(input.files[0].name, 'image')
        : input.files[0].name.split('.').pop() === 'png'
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById('logoImgTag').src = e.target.result
          this.$emit('changeLogoImage', e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>
